export const capitalizeFirstLetter = (str: string): string => {
	if (!str) return ''
	return str.replace(/(^\w|(?<=[-\s])\w)/g, char => char.toUpperCase())
}

export const normalizeIban = (iban: string | undefined) => {
	if (!iban) return ''
	return iban.replace(/\s/g, '')
}

export const formatIban = (iban: string | undefined) => {
	const normalizedIban = normalizeIban(iban)
	if (!normalizedIban) return ''
	return normalizedIban.replace(/^(.{4})(.{4})(.{4})(.{4})(.{4})(.{2})$/, '$1 $2 $3 $4 $5 $6')
}
